import React, {useState} from "react";
import Filter from "./Filter";
import "./Filters.scss";

const Filters = ({filters, reset}) => {
  const [state, setState] = useState(() => {
    return filters.reduce((acc, filter) => {
      acc[filter.name] = filter.selected;
      return acc;
    }, {});
  });

  const handleChange = (filter, value) => {
    setState(prevState => ({...prevState, [filter]: value}));
  };

  return (
    <div className="Filters">
      {filters.map((filter, index) => (
        <Filter key={index} {...filter} reset={reset}/>
      ))}
    </div>
  );
};

export default Filters;
